export const GET_DRIVERS_PENDING = "GET_DRIVERS_PENDING"
export const GET_DRIVERS_SUCCESS = "GET_DRIVERS_SUCCESS"
export const GET_DRIVERS_FAILURE = "GET_DRIVERS_FAILURE"

export const GET_GUARANTORS_PENDING = "GET_GUARANTORS_PENDING"
export const GET_GUARANTORS_SUCCESS = "GET_GUARANTORS_SUCCESS"
export const GET_GUARANTORS_FAILURE = "GET_GUARANTORS_FAILURE"

export const ADD_DRIVER_PENDING = "ADD_DRIVER_PENDING"
export const ADD_DRIVER_SUCCESS = "ADD_DRIVER_SUCCESS"
export const ADD_DRIVER_FAILURE = "ADD_DRIVER_FAILURE"

export const EDIT_DRIVER_PENDING = "EDIT_DRIVER_PENDING"
export const EDIT_DRIVER_SUCCESS = "EDIT_DRIVER_SUCCESS"
export const EDIT_DRIVER_FAILURE = "EDIT_DRIVER_FAILURE"

export const UPLOAD_DRIVER_PENDING = "UPLOAD_DRIVER_PENDING"
export const UPLOAD_DRIVER_SUCCESS = "UPLOAD_DRIVER_SUCCESS"
export const UPLOAD_DRIVER_FAILURE = "UPLOAD_DRIVER_FAILURE"

export const DELETE_DRIVER_PENDING = "DELETE_DRIVER_PENDING"
export const DELETE_DRIVER_SUCCESS = "DELETE_DRIVER_SUCCESS"
export const DELETE_DRIVER_FAILURE = "DELETE_DRIVER_FAILURE"

export const DOWNLOAD_DRIVER_PENDING = "DOWNLOAD_DRIVER_PENDING"
export const DOWNLOAD_DRIVER_SUCCESS = "DOWNLOAD_DRIVER_SUCCESS"
export const DOWNLOAD_DRIVER_FAILURE = "DOWNLOAD_DRIVER_FAILURE"